/** ***
------------------------------------------------------------------------
DETECTIONS (IOCs) LIST PAGE
------------------------------------------------------------------------
  Severity
  Name
  Risk Score
  Detection Time
  Attack Sequence (Values: Attack Trail ID, None. Can hyperlink to Attack Details)
  Kill Chain Tactic
  Host Name (Hover Over - Host OS, Host Version, Local IP, MAC Address)
  Host Type
  User Name

** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const privActionsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Detection Time',
        label: 'Detection Time',
        name: 'seenTime',
        'min-width': 150,
        sortable: true
      },
      {
        datatype: 'number',
        description: 'Detection Rule ID',
        label: 'Rule ID',
        sortable: true,
        'min-width': 100,
        name: 'ruleid'
      },
      {
        datatype: 'objectpath',
        description: 'Detection Rule',
        label: 'Rule',
        sortable: true,
        'min-width': 200,
        name: 'rule.name'
      },
      // {
      //   datatype: 'string',
      //   description: 'Name',
      //   label: 'Name',
      //   name: 'iocSummary',
      //   sortable: true,
      //   'min-width': 250
      // },
      {
        datatype: 'objectpath',
        description: 'Progression ID',
        display: 'link',
        label: 'Progression ID',
        'min-width': 200,
        pathTo: 'attack-track-details',
        params: {
          name: 'trailId',
          keyLookup: 'trailList.trailIdHash'
        },
        sortable: true,
        name: 'trailList.trailIdLabel'
      },
      {
        datatype: 'objectpath',
        description: 'MITRE Tactic',
        label: 'MITRE Tactic',
        'min-width': 150,
        sortable: true,
        name: 'iocTactic',
        display: 'mitrelink',
        link: 'rule.externalTacticUrl',
        linkLabel: {
          labelId: 'rule.tactic',
          labelName: 'rule.mitreAttackTactic.name'
        }
      },
      {
        datatype: 'objectpath',
        description: 'MITRE Technique',
        label: 'MITRE Technique',
        'min-width': 250,
        sortable: true,
        name: 'iocTactic',
        display: 'mitrelink',
        link: 'rule.externalTechniqueUrl',
        linkLabel: {
          labelId: 'rule.technique',
          labelName: 'rule.mitreAttackTechnique.name'
        }
      },
      {
        datatype: 'objectpath',
        description: 'Hostname',
        label: 'Hostname',
        'min-width': 200,
        sortable: true,
        name: 'host.customHostname'
      },
      {
        datatype: 'objectpath',
        description: 'Operating System',
        display: 'icon',
        label: 'OS',
        name: 'host.system.os',
        displayKey: [
          { key: 'linux', icon: 'fab fa-linux' },
          { key: 'windows', icon: 'fab fa-windows' }
        ]
      },
      {
        datatype: 'objectpath',
        description: 'Local IP',
        display: 'array',
        label: 'Local IP',
        sortable: true,
        'min-width': 200,
        name: 'host.localIPs'
      }
    ]
  }
}

export { privActionsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/detections/priv-actions-meta.js